import Immutable from 'immutable';
import StaticLookup from './staticlookup';



const EMPTY_LOOKUP = StaticLookup(Immutable.List([]));


let _getLookup = function() {
	return EMPTY_LOOKUP;
};

export function getLookup(name, fixedParams) {
	let res = _getLookup(name) || EMPTY_LOOKUP;
	if (fixedParams && res.withFixedParams) {
		res = res.withFixedParams(fixedParams);
	}
	return res;
}

export function initializeLookupStore(func) {
	_getLookup = func;
}
